__turbopack_context__.v({
  "kbd": "-U4ZKq_kbd",
  "lg": "-U4ZKq_lg",
  "md": "-U4ZKq_md",
  "primary": "-U4ZKq_primary",
  "secondary": "-U4ZKq_secondary",
  "sm": "-U4ZKq_sm",
});
